import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

enum Status {
  SENT_TO_LAB = 'Sent to lab',
  RECEIVED_AT_LAB = 'Received at lab',
  IN_MRO_REVIEW = 'In MRO Review',
  PENDING_CCF = 'Pending CCF',
  EXPIRED = 'Expired'
}

@inheritSerialization(AbstractModel)
export class SubstanceScreeningStatus extends AbstractModel {
  @autoserialize
  transmissionId: string;

  @autoserializeAs(Status)
  status: string;

  @autoserializeAs(Date)
  reportedDate: Date;

  public static OnSerialized(instance: SubstanceScreeningStatus, json: any): void {
    super.OnSerialized(instance, json);
    if (!isNullOrUndefined(instance.reportedDate)) {
      json.reportedDate = DateUtil.serializeDate(instance.reportedDate);
    }
  }

  public static OnDeserialized(instance: SubstanceScreeningStatus, json: any): void {
    super.OnDeserialized(instance, json);
    if (!isNullOrUndefined(json['reportedDate'])) {
      instance.reportedDate = DateUtil.deserializeDate(json['reportedDate']);
    }
  }
}
